export enum StoredCollectionNames {
  STORED_CONTEXTS = 'stored_contexts',
  STORED_MATCH_STEMS = 'stored_match_stems'
}
